export default __webpack_public_path__ + "static/media/02.3-az-foods.4246e39f.png";